import React from "react";
import { registerAppBackHandler, type AppBackHandler, type AppBackHandlerOptions } from "./appBack";

/**
 * Регистрирует обработчик `App Back` на время жизни компонента.
 * @param handler обработчик, возвращающий `true`, если действие обработано
 * @param options настройки приоритета обработки
 */
export function useAppBackHandler(handler: AppBackHandler, options: AppBackHandlerOptions = {}): void {
    const priority = options.priority;

    React.useEffect(() => registerAppBackHandler(handler, { priority }), [handler, priority]);
}
